<template>
  <div class="home">
    <LockList :lock="lock"/>
  </div>
</template>

<script>
import LockList from '@/components/lock/LockList.vue'
export default {
  name: 'Lock',
  components: {
    LockList
  },
  data () {
    return {
      lock: {
        id: null,
        username: null,
        user: null,
        request_by: null,
        request: {
          id: 0,
          name: null,
          username: null,
          email: null,
          outlet_code: null
        },
        lock_no: null,
        lock_date: null,
        lock_note: null,
        token: null,
        lock: false,
        status: null,
        type: null
      }
    }
  }
}
</script>
